/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_WhereInputs */

const en_us2_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which exercise?`)
};

const pt_br2_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em qual exercício?`)
};

const es_419_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué ejercicio?`)
};

const pt_pt2_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que exercício?`)
};

const fr_fr2_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel exercice ?`)
};

const de_de2_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Übung?`)
};

const it_it2_workout_after_pain_where = /** @type {(inputs: Workout_After_Pain_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In quale esercizio?`)
};

/**
* | output |
* | --- |
* | "Which exercise?" |
*
* @param {Workout_After_Pain_WhereInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_where = /** @type {((inputs?: Workout_After_Pain_WhereInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_WhereInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_where(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_where(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_where(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_where(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_where(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_where(inputs)
	return en_us2_workout_after_pain_where(inputs)
});
export { workout_after_pain_where as "workout-after.pain_where" }